// Define a class for the Swiper component that extends the HTMLElement class
class SwiperComponent extends HTMLElement {
  // The constructor is called when an object is created with the class
  constructor() {
    super(); // Call the parent class constructor
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  connectedCallback() {
    this.initSwiper(); // Initialize the Swiper when the component is connected

    // Add event listeners
    document.addEventListener('shopify:section:load', this.initSwiper);
    document.addEventListener('shopify:section:reorder', this.initSwiper);
    document.addEventListener('shopify:section:select', this.initSwiper);
    document.addEventListener('shopify:block:select', this.initSwiper);
  }

  // Method to initialize the Swiper
  initSwiper() {
    // Define the options for the Swiper
    const swiperOptions = {
      slidesPerView: 1.55, // Number of slides per view
      spaceBetween: 8, // Space between slides
      breakpoints: { // Breakpoints for different screen widths
        1024: {
          slidesPerView: 4,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 8,
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    };

    // Initialize the Swiper with the options
    new Swiper(this, swiperOptions);
  }
}

// Define the custom element
customElements.define("reviews-swiper-component", SwiperComponent);

// Define a class for the Swiper component that extends the HTMLElement class
class RelatedProductsSwiperComponent extends HTMLElement {
  // The constructor is called when an object is created with the class
  constructor() {
    super(); // Call the parent class constructor
  }

  // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
  connectedCallback() {
    this.initSwiper(); // Initialize the Swiper when the component is connected

    // Add event listeners
    document.addEventListener('shopify:section:load', this.initSwiper);
    document.addEventListener('shopify:section:reorder', this.initSwiper);
    document.addEventListener('shopify:section:select', this.initSwiper);
    document.addEventListener('shopify:block:select', this.initSwiper);
  }

  // Method to initialize the Swiper
  initSwiper() {
    // Define the options for the Swiper
    const swiperOptions = {
      slidesPerView: 1.3, // Number of slides per view
      spaceBetween: 10, // Space between slides
      breakpoints: { // Breakpoints for different screen widths
        1024: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    };

    // Initialize the Swiper with the options
    new Swiper(this, swiperOptions);
  }
}

// Define the custom element
customElements.define("related-products-swiper-component", RelatedProductsSwiperComponent);